import React from "react";
import { Box, Typography, Container, Button, Stack } from "@mui/material";

const HeroBanner = () => (
  <Box
    sx={{
      backgroundImage: "url('/images/shopPage/shop-hero.png')",
      backgroundSize: "cover",
      backgroundPosition: { xs: "center top", md: "center" },
      minHeight: { xs: 360, md: 600 },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      textAlign: "center",
      position: "relative",
    }}>
    <Container>
      <Box
        sx={{
          backgroundColor: "rgba(0,0,0,0.4)", // semi-transparent dark overlay
          px: { xs: 1, md: 5 },
          py: { xs: 3, md: 5 },
          borderRadius: 2,
          maxWidth: 600,
          mx: "auto",
        }}>
        <Stack spacing={2}>
          <Typography variant="h3" fontWeight="bold">
            Celebrate Every Moment
          </Typography>
          <Typography variant="h6">
            Shop cakes, pastries, and sweet gifts 🍰
          </Typography>
          <Button
            variant="contained"
            size="large"
            href="#categories"
            sx={{
              backgroundColor: "#FD7762",
              ":hover": { backgroundColor: "#e46052" },
            }}>
            Start Shopping
          </Button>
        </Stack>
      </Box>
    </Container>
  </Box>
);

export default HeroBanner;
